import PhotoEditor from './photo-editor';

export default PhotoEditor;
